import React, { useState } from 'react';
import IconoUno from './../img/NuestroShop/icono-1.png';
import IconoDos from './../img/NuestroShop/icono-2.png';
import IconoTres from './../img/NuestroShop/icono-3.png';

function BackOfficeMenu() {

    const [botones, setBotones] = useState([
        {
            name: "Sucursal",
            icon: IconoUno,
            link: "/sucursal",
            size: [1, 1] // Relación de aspecto 1:1
        },
        {
            name: "Sucursales",
            icon: IconoDos,
            link: "/sucursales",
            size: [2, 1] // Relación de aspecto 2:1 (más ancho)
        },
        {
            name: "Servicios",
            icon: IconoTres,
            link: "/servicios",
            size: [1, 2] // Relación de aspecto 1:2 (más alto)
        },
        {
            name: "Configuración",
            icon: IconoUno,
            link: "/configuracion",
            size: [2, 2] // Relación de aspecto 2:2
        },
        {
            name: "Noticias",
            icon: IconoDos,
            link: "/noticias",
            size: [3, 1] // Relación de aspecto 3:1 (más ancho)
        },
        {
            name: "Sucursal",
            icon: IconoUno,
            link: "/sucursal",
            size: [1, 1] // Relación de aspecto 1:1
        },
        {
            name: "Sucursales",
            icon: IconoDos,
            link: "/sucursales",
            size: [2, 1] // Relación de aspecto 2:1 (más ancho)
        },
        {
            name: "Servicios",
            icon: IconoTres,
            link: "/servicios",
            size: [1, 2] // Relación de aspecto 1:2 (más alto)
        },
        {
            name: "Configuración",
            icon: IconoUno,
            link: "/configuracion",
            size: [2, 2] // Relación de aspecto 2:2
        },
        {
            name: "Noticias",
            icon: IconoDos,
            link: "/noticias",
            size: [3, 1] // Relación de aspecto 3:1 (más ancho)
        },
        {
            name: "Sucursal",
            icon: IconoUno,
            link: "/sucursal",
            size: [1, 1] // Relación de aspecto 1:1
        },
        {
            name: "Sucursales",
            icon: IconoDos,
            link: "/sucursales",
            size: [2, 1] // Relación de aspecto 2:1 (más ancho)
        },
        {
            name: "Servicios",
            icon: IconoTres,
            link: "/servicios",
            size: [1, 2] // Relación de aspecto 1:2 (más alto)
        },
        {
            name: "Configuración",
            icon: IconoUno,
            link: "/configuracion",
            size: [2, 2] // Relación de aspecto 2:2
        },
        {
            name: "Noticias",
            icon: IconoDos,
            link: "/noticias",
            size: [3, 1] // Relación de aspecto 3:1 (más ancho)
        }
    ]);

    return (
        <div 
            style={{
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', 
                gap: '10px', 
                width: '100%'
            }}
        >
            {botones.map((boton, index) => (
                <a 
                    key={index} 
                    href={boton.link} 
                    style={{
                        display: 'flex', 
                        justifyContent: 'center', 
                        alignItems: 'center', 
                        background: '#f0f0f0', 
                        borderRadius: '8px', 
                        padding: '10px', 
                        textDecoration: 'none',
                        color:'black',
                        fontWeight: 800,
                        gridColumn: `span ${boton.size[0]}`, // Utiliza el valor de size[0] para el ancho
                        gridRow: `span ${boton.size[1]}`,    // Utiliza el valor de size[1] para el alto
                    }}
                >
                    <img 
                        src={boton.icon} 
                        alt={boton.name} 
                        style={{ width: '50px', height: '50px', marginRight: '10px' }} 
                    />
                    <span>{boton.name}</span>
                </a>
            ))}
        </div>
    );
}

export default BackOfficeMenu;
